import salesApply from "./page/invoiceManager/salesManager/sales-apply";
import approveDetails from "./page/invoiceManager/incomeManager/approve-details";
import inputInvoiceDetail from "./page/invoiceManager/salesManager/inputInvoiceDetail";
import inTheExamine from "./page/engineering/inTheMatter/examine";
import beforDeleteDetail from "./page/engineering/beforehand/deleteDetail";
import inTheHistoryEdition from "./page/engineering/inTheMatter/historyEdition";
import inTheDeleteDetail from "./page/engineering/inTheMatter/deleteDetail";
import sporadicIndex from "./page/engineering/sporadic/index";
import sporadicAdd from "./page/engineering/sporadic/addAndModify";
import sporadicModify from "./page/engineering/sporadic/addAndModify";
import sporadicDetail from "./page/engineering/sporadic/details";
import expenditureSummary from "./page/engineering/expenditureSummary";
import workbench from "./page/workbench/workbench";
import pendingApproval from "./page/workbench/pendingApproval";
import approvalHistory from "./page/workbench/approvalHistory";
import manageIndex from "@/page/institution/manage/index";
import lookUpDetails from "@/page/institution/lookUp/details";
import manageAddAndModify from "@/page/institution/manage/addAndModify";
import documentManage from "@/page/document/manage/index";
import incomingManage from "@/page/document/incomingManage/index";
import documentManagePrint from "@/page/document/manage/print";
import incomingManageAddAndModiify from "@/page/document/incomingManage/addAndModiify";
import incomingApprovalDetails from "@/page/document/incomingApproval/details";
import documentManageDetails from "@/page/document/manage/detailAndApprove";
import incomingManageDetails from "./page/document/incomingManage/detailAndApprove";
import projectSheet from "./page/engineering/projectSheet";
import processingSendAndApprove from "@/page/document/manage/processing/sendAndApprove";
import controlPriceDetail from "@/page/inviteBids/controlPrice/detail";


export default {
  home: "home",
  management: "",

  //数据中心
  payAppliable: {
    title: "付款申请",
    name: "付款申请",
    component: "app-payTotal",
  },
  // payProjectDeptDataSingle: {
  //   title: "项目部看板",
  //   name: "项目部看板",
  //   component: "app-payProjectDeptDataSingle"
  // },
  // payProjectData: {
  //   title: "项目看板",
  //   name: "项目看板",
  //   component: "app-payProjectData"
  // },

  payDataSource: {
    title: "付款申请数据源",
    name: "付款申请数据源",
    component: "app-payDataSource",
  },
  accountsReceivable: {
    title: "应收账款",
    name: "应收账款",
    component: "app-accountsReceiveTotal",
  },

  // receiveProjectDeptDataSingle: {
  //   title: "项目部看板",
  //   name: "项目部看板",
  //   component: "app-receiveProjectDeptDataSingle"
  // },
  // receiveProjectData: {
  //   title: "项目看板",
  //   name: "项目看板",
  //   component: "app-receiveProjectData"
  // },
  accountsReceiveDataSource: {
    title: "应收账款数据源",
    name: "应收账款数据源",
    component: "app-accountsReceiveDataSource",
  },

  payAppliableA: {
    title: "付款申请",
    name: "付款申请",
    component: "app-payTotalA",
  },
  accountsReceivableA: {
    title: "应收账款",
    name: "应收账款",
    component: "app-accountsReceiveTotalA",
  },

  costTotal: {
    title: "收入成本毛利",
    name: "收入成本毛利",
    component: "app-costTotal",
  },

  costDataSource: {
    title: "成本数据源",
    name: "成本数据源",
    component: "app-costDataSource",
  },

  //系统管理
  menuSetting: {
    title: "菜单管理",
    name: "菜单管理",
    component: "app-menuSetting",
  },
  accountSetting: {
    title: "账号管理",
    name: "账号管理",
    component: "app-accountSetting",
  },
  postSetting: {
    title: "岗位管理",
    name: "岗位管理",
    component: "app-postSetting",
  },
  roleSetting: {
    title: "角色管理",
    name: "角色管理",
    component: "app-roleSetting",
  },
  govermentSetting: {
    title: "城市管理",
    name: "城市管理",
    component: "app-citySetting",
  },
  govSetting: {
    title: "组织管理",
    name: "组织管理",
    component: "app-govSetting",
  },
  configSetting: {
    title: "字典管理",
    name: "字典管理",
    component: "app-configSetting",
  },
  crontabSetting: {
    title: "字典详情管理",
    name: "字典详情管理",
    component: "app-BasicDataDetailSetting",
  },

  govMenuSetting: {
    title: "组织权限维护",
    name: "组织权限维护",
    component: "app-govMenuSetting",
  },

  ApproveSetting: {
    title: "审批流设置",
    name: "审批流设置",
    component: "app-ApproveSetting",
  },
  buildSetting: {
    title: "部门管理",
    name: "部门管理",
    component: "app-buildSetting",
  },

  latestNews: {
    title: "消息中心",
    name: "消息中心",
    component: "app-latestNews",
  },
  latestDocumentNews: {
    title: "公文消息",
    name: "公文消息",
    component: "app-latestDocumentNews",
  },
  "payment-cycle": {
    //总包合同
    title: "总包合同",
    name: "总包合同",
    component: "pc-AllContractMag",
  },
  "find-classify": {
    title: "创建总包合同",
    name: "创建总包合同",
    component: "pc-addContract",
  },
  "find-report": {
    title: "编辑总包合同",
    name: "编辑总包合同",
    component: "pc-editContract",
  },
  mineReVisitList: {
    title: "查看总包合同",
    name: "查看总包合同",
    component: "pc-selectContract",
  },
  relationWorkList: {
    title: "查看总包合同",
    name: "审核总包合同",
    component: "pc-approveContract",
  },
  "payment-parkfeeRelation": {
    title: "项目管理",
    name: "项目管理",
    component: "pc-projectMag",
  },
  "find-setting": {
    title: "新增项目立项单",
    name: "新增项目立项单",
    component: "pc-addproject",
  },
  totalReVisitList: {
    title: "编辑项目立项单",
    name: "编辑项目立项单",
    component: "pc-editproject",
  },
  ApproveRule: {
    title: "立项审批制度",
    name: "立项审批制度",
    component: "pc-ApproveRule",
  },
  ContractApproveRule: {
    title: "合同审批制度",
    name: "合同审批制度",
    component: "pc-ContractApproveRule",
  },
  houseDeliveMgr: {
    title: "查看项目立项单",
    name: "查看项目立项单",
    component: "pc-selectproject",
  },
  addHouseDelive: {
    title: "查看项目立项单",
    name: "审批项目立项单",
    component: "pc-approveproject",
  },
  complaintReportingSta: {
    title: "工程项目配置",
    name: "工程项目配置",
    component: "pc-ProjectMsgSet",
  },
  "payment-orderCheck": {
    title: "劳务合同",
    name: "劳务合同",
    component: "pc-subContractMag",
  },
  buyContract: {
    title: "材料合同",
    name: "材料合同",
    component: "pc-buyContract",
  },
  machineryContractMag: {
    title: "机械合同",
    name: "机械合同",
    component: "pc-machineryContractMag",
  },
  otherContract: {
    title: "其他合同",
    name: "其他合同",
    component: "pc-otherContract",
  },
  modQuestionnaire: {
    title: "新建分项合同",
    name: "新建分项合同",
    component: "pc-addSubContract",
  },

  roomBindingSta: {
    title: "编辑分项合同",
    name: "编辑分项合同",
    component: "pc-editSubContract",
  },
  approveDetail: {
    title: "追加补充协议",
    name: "追加补充协议",
    component: "pc-AddSupplementary",
  },

  innerApproveDetail: {
    title: "编辑补充协议",
    name: "编辑补充协议",
    component: "pc-EditSupplementary",
  },
  totalApproveList: {
    title: "查看分项合同",
    name: "查看劳务合同",
    component: "pc-selectSubContract",
  },
  mineApproveList: {
    title: "查看分项合同",
    name: "审批劳务合同",
    component: "pc-approveSubContract",
  },
  //------基础数据--------
  projectNumListTab: {
    title: "工程量清单",
    name: "工程量清单",
    component: "pc-projectNumListTab",
  },
  projectNumSubListTab: {
    title: "内部定额表",
    name: "内部定额表",
    component: "pc-projectNumSubListTab",
  },

  materialNumListTab: {
    title: "物资清单",
    name: "物资清单",
    component: "pc-materialNumListTab",
  },
  rulesListTab: {
    title: "规章制度",
    name: "规章制度",
    component: "pc-rulesListTab",
  },
  editrulesTab: {
    title: "编辑规章制度",
    name: "编辑规章制度",
    component: "pc-editrulesTab",
  },
  supplierList: {
    title: "供应商列表",
    name: "供应商列表",
    component: "pc-supplierTable",
  },
  "supplierAListPage": {
    title: "合作单位(甲)管理",
    name: "合作单位(甲)管理",
    component: "pc-supplierAListPage"
  },
  "addSupplierAPage": {
    title: "录入甲方信息",
    name: "录入甲方信息",
    component: "pc-addSupplierAPage"
  },

  "editSupplierAPage": {
    title: "修改甲方信息",
    name: "修改甲方信息",
    component: "pc-editSupplierAPage"
  },
  "supplierDetail": {
    title: "企业详情",
    name: "企业详情",
    component: "pc-supplierDetail"
  },

  "supplierAApprove": {
    title: "合作单位(乙)审核",
    name: "合作单位(乙)审核",
    component: "pc-supplierAApprove"
  },
  "supplierBApprove": {
    title: "审核",
    name: "审核",
    component: "pc-supplierBApprove"
  },
  "supplierAApproveDetail": {
    title: "审核详情",
    name: "审核详情",
    component: "pc-supplierAApproveDetail"
  },


  "supplierSetTree": {
    title: "合作单位(乙)分类",
    name: "合作单位(乙)分类",
    component: "pc-supplierSetTree"
  },
  "supplierBSelfMag": {
    title: "企业信息(乙)维护",
    name: "企业信息(乙)维护",
    component: "pc-supplierBSelfMag"
  },

  "addSupplierBSelfPage": {
    title: "新建企业信息(乙)",
    name: "新建企业信息(乙)",
    component: "pc-addSupplierBSelfPage"
  },

  "editSupplierBSelfPage": {
    title: "修改企业信息(乙)",
    name: "修改企业信息(乙)",
    component: "pc-editSupplierBSelfPage"
  },

  "supplierBListPage": {
    title: "我的企业信息",
    name: "我的企业信息",
    component: "pc-supplierBListPage"
  },
  "addSupplierBPage": {
    title: "新建企业信息",
    name: "新建企业信息",
    component: "pc-addSupplierBPage"
  },

  "editSupplierBPage": {
    title: "修改企业信息",
    name: "修改企业信息",
    component: "pc-editSupplierBPage"
  },

  "supplierBAccount": {
    title: "合作单位(乙)账号管理",
    name: "合作单位(乙)账号管理",
    component: "pc-supplierBAccount"
  },

  "evaluateSupplierList": {
    title: "合作单位评价",
    name: "合作单位评价",
    component: "pc-evaluateSupplierList"
  },

  "evaluateAccountSet": {
    title: "评价账号设置",
    name: "评价账号设置",
    component: "pc-evaluateAccountSet"
  },

  //-------会议相关---------------
  meetingList: {
    title: "会议提报单",
    name: "会议提报单",
    component: "pc-MeetingBillList",
  },
  createMeetingBill: {
    title: "创建会议提报单",
    name: "创建会议提报单",
    component: "pc-AddMeetingBill",
  },
  meetingBillDetailView: {
    title: "查看会议提报单",
    name: "查看会议提报单",
    component: "pc-MeetingBillDetail",
  },
  meetingBillEdit: {
    title: "修改会议提报单",
    name: "修改会议提报单",
    component: "pc-MeetingBillEdit",
  },
  "general-meeting": {
    title: "综合议题会议列表",
    name: "综合议题会议列表",
    component: "pc-GeneralMeetingList",
  },
  "other-meeting": {
    title: "其它专题会议列表",
    name: "其它专题会议列表",
    component: "pc-OtherMeetingList",
  },
  createGeneralMeeting: {
    title: "创建综合议题会议",
    name: "创建综合议题会议",
    component: "pc-CreateGeneralMeeting",
  },
  generalMeetingDetail: {
    title: "查看综合议题会议",
    name: "查看综合议题会议",
    component: "pc-GeneralMeetingDetail",
  },
  editGeneralMeeting: {
    title: "修改综合议题会议",
    name: "修改综合议题会议",
    component: "pc-EditGeneralMeeting",
  },
  createOtherMeeting: {
    title: "创建其他专题会议",
    name: "创建其他专题会议",
    component: "pc-CreateOtherMeeting",
  },
  otherMeetingDetail: {
    title: "其他专题会议详情",
    name: "其他专题会议详情",
    component: "pc-OtherMeetingDetail",
  },
  editOtherMeeting: {
    title: "修改其他专题会议",
    name: "修改其他专题会议",
    component: "pc-OtherMeetingEdit",
  },
  groupManage: {
    title: "群组管理",
    name: "群组管理",
    component: "app-groupManage",
  },
  groupDetail: {
    title: "群组详情",
    name: "群组详情",
    component: "app-groupDetail",
  },
  //-------------付款明细相关-----------------------
  paymentList: {
    title: "付款明细列表",
    name: "付款明细列表",
    component: "pc-paymentlist",
  },
  createPayment: {
    title: "新建付款明细",
    name: "新建付款明细",
    component: "pc-createpayment",
  },
  editPayment: {
    title: "编辑付款明细",
    name: "编辑付款明细",
    component: "pc-editpayment",
  },
  paymentDetail: {
    title: "付款明细详情",
    name: "付款明细详情",
    component: "pc-paymentdetail",
  },
  paymentApplyList: {
    title: "付款申请列表",
    name: "付款申请列表",
    component: "pc-paymentapplylist",
  },
  createPaymentApply: {
    title: "创建付款申请",
    name: "创建付款申请",
    component: "pc-AddMeetingBill", // 付款申请跟提报单是一个东西，只是付款申请里不能切换类型
  },
  paymentApplyDetailView: {
    title: "查看付款申请",
    name: "查看付款申请",
    component: "pc-MeetingBillDetail",
  },
  paymentApplyEdit: {
    title: "修改付款申请",
    name: "修改付款申请",
    component: "pc-MeetingBillEdit",
  },
  //------ 收款管理---------
  collectionList: {
    title: "收款列表",
    name: "收款列表",
    component: "pc-collectionlist",
  },
  createCollection: {
    title: "新建收款记录",
    name: "新建收款记录",
    component: "pc-createcollection",
  },
  editCollection: {
    title: "编辑收款记录",
    name: "编辑收款记录",
    component: "pc-editcollection",
  },
  collectionDetail: {
    title: "查看收款记录",
    name: "查看收款记录",
    component: "pc-collectiondetail",
  },
  //-----收入成本管理---
  incomeConstList: {
    title: "收入列表",
    name: "收入列表",
    component: "pc-incomecostlist",
  },
  incomingConstDetail: {
    title: "收入成本详情",
    name: "收入成本详情",
    component: "pc-incomeconstdetail",
  },
  CreateEarningItem: {
    title: "新建收入记录",
    name: "新建收入记录",
    component: "pc-CreateEarningItem",
  },
  EditEarningItem: {
    title: "编辑收入记录",
    name: "编辑收入记录",
    component: "pc-EditEarningItem",
  },
  //------------jzy-InvoiceManager-start-----------
  salesInvoice: {
    title: "销项发票申请列表",
    name: "销项发票申请列表",
    component: "pc-salesInvoice"
  },
  salesInvoiceDetail: {
    title: "销项发票申请详情",
    name: "销项发票申请详情",
    component: "pc-salesInvoiceDetail"
  },
  salesApply: {
    title: "发起申请",
    name: "发起申请",
    component: "pc-salesApply"
  },
  salesInput: {
    title: "发票录入",
    name: "发票录入",
    component: "pc-salesInput"
  },
  inputInvoice: {
    title: "录入发票列表",
    name: "录入发票列表",
    component: "pc-inputInvoice"
  },
  inputInvoiceDetail: {
    title: "录入发票详情",
    name: "录入发票详情",
    component: "pc-inputInvoiceDetail"
  },
  inputConfirm: {
    title: "确认收款",
    name: "确认收款",
    component: "pc-inputConfirm"
  },
  statistics: {
    title: "销项发票统计",
    name: "销项发票统计",
    component: "pc-statistics"
  },
  incomeInvoice: {
    title: "进项发票",
    name: "进项发票",
    component: "pc-incomeInvoice"
  },
  incomeInvoiceDetail: {
    title: "进项发票详情",
    name: "进项发票详情",
    component: "pc-incomeInvoiceDetail"
  },
  incomeInput: {
    title: "发票录入",
    name: "发票录入",
    component: "pc-incomeInput"
  },
  incomeApprove: {
    title: "进项发票审批",
    name: "进项发票审批",
    component: "pc-incomeApprove"
  },
  approveDetails: {
    title: "进项发票审批详情",
    name: "进项发票审批详情",
    component: "pc-approveDetails"
  },
  reimbursement: {
    title: "报销审批",
    name: "报销审批",
    component: "pc-reimbursement"
  },
  invoiceClaim: {
    title: "发票认领",
    name: "发票认领",
    component: "pc-invoiceClaim"
  },
  claimTaxAmount: {
    title: "发票认领进项税额",
    name: "发票认领进项税额",
    component: "pc-claimTaxAmount"
  },
  invoiceClaimDetail: {
    title: "发票认领详情",
    name: "发票认领详情",
    component: "pc-invoiceClaimDetail"
  },
  incomeStatistics: {
    title: "进项发票统计",
    name: "进项发票统计",
    component: "pc-incomeStatistics"
  },
  appletSetting: {
    title: "小程序管理",
    name: "小程序管理",
    component: "pc-appletSetting"
  },
  //------------jzy-InvoiceManager-end-----------

  //------------jzy-Engineering-start-----------
  beforExamine: {
    title: "事前成本审核",
    name: "事前成本审核",
    component: "pc-beforExamine"
  },
  beforIndex: {
    title: "事前成本",
    name: "事前成本",
    component: "pc-beforIndex"
  },
  beforDeleteDetail: {
    title: "删除细目",
    name: "删除细目",
    component: "pc-beforDeleteDetail"
  },
  beforInfoDetails: {
    title: "详情",
    name: "详情",
    component: "pc-beforInfoDetails"
  },
  beforHistoryEdition: {
    title: "历史版本",
    name: "历史版本",
    component: "pc-beforHistoryEdition"
  },
  inTheExamine: {
    title: "事中成本审核",
    name: "事中成本审核",
    component: "pc-inTheExamine"
  },
  inTheIndex: {
    title: "事中成本",
    name: "事中成本",
    component: "pc-inTheIndex"
  },
  inTheHistoryEdition: {
    title: "历史版本",
    name: "历史版本",
    component: "pc-inTheHistoryEdition"
  },
  inTheDeleteDetail: {
    title: "删除细目",
    name: "删除细目",
    component: "pc-inTheDeleteDetail"
  },
  sporadicIndex: {
    title: "零星工程量",
    name: "零星工程量",
    component: "pc-sporadicIndex"
  },
  sporadicAdd: {
    title: "新增零星工程量",
    name: "新增零星工程量",
    component: "pc-sporadicAdd"
  },
  sporadicModify: {
    title: "修改零星工程量",
    name: "修改零星工程量",
    component: "pc-sporadicModify"
  },
  sporadicDetail: {
    title: "零星工程量详情",
    name: "零星工程量详情",
    component: "pc-sporadicDetail"
  },
  inTheInfoDetails: {
    title: "详情",
    name: "详情",
    component: "pc-inTheInfoDetails"
  },
  expenditureSummary: {
    title: "成本支出汇总表",
    name: "成本支出汇总表",
    component: "pc-expenditureSummary"
  },
  projectSheet: {
    title: "工程结算单",
    name: "工程结算单",
    component: "pc-projectSheet"
  },
  expenditureStatistics: {
    title: "成本支出统计表",
    name: "成本支出统计表",
    component: "pc-expenditureStatistics"
  },
  //------------jzy-Engineering-end-----------
  //其他直接费
  otherDirectFee: {
    title: "其他直接费",
    name: "其他直接费",
    component: "pc-otherDirectFee"
  },
  directDeleteDetail: {
    title: "删除细目",
    name: "删除细目",
    component: "pc-directDeleteDetail"
  },
  //措施费
  measureFee: {
    title: "措施费",
    name: "措施费",
    component: "pc-measureFee"
  },
  measureDeleteDetail: {
    title: "删除细目",
    name: "删除细目",
    component: "pc-measureDeleteDetail"
  },

  //------------jzy-institution-start-----------
  lookUpIndex: {
    title: "制度查阅",
    name: "制度查阅",
    component: "pc-lookUpIndex"
  },
  manageIndex: {
    title: "制度管理",
    name: "制度管理",
    component: "pc-manageIndex"
  },
  cancelIndex: {
    title: "已作废制度",
    name: "已作废制度",
    component: "pc-cancelIndex"
  },

  //-------工作台 审批  start------------------------
  workbench:{
    title: "工作台",
    name: "工作台",
    component: "pc-workbench"
  },
  pendingApproval:{
    title: "待审批列表",
    name: "待审批列表",
    component: "pc-pendingApproval"
  },
  rejectedApproval:{
    title: "已驳回申请",
    name: "已驳回申请",
    component: "pc-rejectedApproval"
  },
  approvalHistory:{
    title: "审批历史",
    name: "审批历史",
    component: "pc-approvalHistory"
  },

  submitUnapproval:{
    title: "已提交未审批",
    name: "已提交未审批",
    component: "pc-submitUnapproval"
  },

  //-------工作台 审批  end------------------------

  lookUpDetails: {
    title: "制度查阅详情",
    name: "制度查阅详情",
    component: "pc-lookUpDetails"
  },
  manageAdd: {
    title: "制度新建",
    name: "制度新建",
    component: "pc-manageAdd"
  },
  generalOfficeAdd: {
    title: "发文",
    name: "发文",
    component: "pc-generalOfficeAdd"
  },
  generalOfficeModiify: {
    title: "发文修改",
    name: "发文修改",
    component: "pc-generalOfficeModiify"
  },
  generalOfficeDetails: {
    title: "发文详情",
    name: "发文详情",
    component: "pc-generalOfficeDetails"
  },
  processingSendAndApprove: {
    title: "收文处理",
    name: "收文处理",
    component: "pc-processingSendAndApprove"
  },
  processingDetails: {
    title: "收文处理详情",
    name: "收文处理详情",
    component: "pc-processingDetails"
  },
  manageModify: {
    title: "制度修改",
    name: "制度修改",
    component: "pc-manageModify"
  },
  manageDetails: {
    title: "制度详情",
    name: "制度详情",
    component: "pc-manageDetails"
  },
  documentManage: {
    title: "公文管理",
    name: "公文管理",
    component: "pc-documentManage"
  },
  documentManageAdd: {
    title: "公文-新增",
    name: "公文-新增",
    component: "pc-documentManageAdd"
  },
  documentManageModiify: {
    title: "公文-修改",
    name: "公文-修改",
    component: "pc-documentManageModiify"
  },
  documentManageDetails: {
    title: "公文详情",
    name: "公文详情",
    component: "pc-documentManageDetails"
  },
  documentManagePrint: {
    title: "公文-打印",
    name: "公文-打印",
    component: "pc-documentManagePrint"
  },
  documentApproval: {
    title: "公文审批",
    name: "公文审批",
    component: "pc-documentApproval"
  },
  documentApprovalDetails: {
    title: "公文审批详情",
    name: "公文审批详情",
    component: "pc-documentApprovalDetails"
  },
  incomingManage: {
    title: "收文管理",
    name: "收文管理",
    component: "pc-incomingManage"
  },
  incomingManageAdd: {
    title: "收文-新增",
    name: "收文-新增",
    component: "pc-incomingManageAdd"
  },
  incomingManageModiify: {
    title: "收文-修改",
    name: "收文-修改",
    component: "pc-incomingManageModiify"
  },
  incomingManageDetails: {
    title: "收文详情",
    name: "收文详情",
    component: "pc-incomingManageDetails"
  },
  incomingManagePrint: {
    title: "收文-打印",
    name: "收文-打印",
    component: "pc-incomingManagePrint"
  },
  incomingApproval: {
    title: "收文审批",
    name: "收文审批",
    component: "pc-incomingApproval"
  },
  incomingApprovalDetails: {
    title: "收文审批详情",
    name: "收文审批详情",
    component: "pc-incomingApprovalDetails"
  },
  documentClassifyManage: {
    title: "公文分类管理",
    name: "公文分类管理",
    component: "pc-documentClassifyManage"
  },
  //采购管理
  bidPlan: {
    title: "采购计划",
    name: "采购计划",
    component: "pc-bidPlan"
  },
  bidPlanAdd: {
    title: "新增采购计划",
    name: "新增采购计划",
    component: "pc-bidPlanAdd"
  },
  bidPlanEdit: {
    title: "编辑采购计划",
    name: "编辑采购计划",
    component: "pc-bidPlanEdit"
  },
  bidPlanDetail: {
    title: "采购计划详情",
    name: "采购计划详情",
    component: "pc-bidPlanDetail"
  },
  controlPrice: {
    title: "控制价审核",
    name: "控制价审核",
    component: "pc-controlPrice"
  },
  controlPriceAdd: {
    title: "新增控制价",
    name: "新增控制价",
    component: "pc-controlPriceAdd"
  },
  controlPriceEdit: {
    title: "编辑控制价",
    name: "编辑控制价",
    component: "pc-controlPriceEdit"
  },
  controlPriceDetail: {
    title: "控制价详情",
    name: "控制价详情",
    component: "pc-controlPriceDetail"
  },

  bidFile: {
    title: "采购文件审核",
    name: "采购文件审核",
    component: "pc-bidFile"
  },
  bidFileAdd: {
    title: "新增采购文件",
    name: "新增采购文件",
    component: "pc-bidFileAdd"
  },
  bidFileEdit: {
    title: "编辑采购文件",
    name: "编辑采购文件",
    component: "pc-bidFileEdit"
  },
  bidFileDetail: {
    title: "采购文件详情",
    name: "采购文件详情",
    component: "pc-bidFileDetail"
  },

  bidOrder: {
    title: "联签单",
    name: "联签单",
    component: "pc-bidOrder"
  },
  bidOrderAdd: {
    title: "新增联签单",
    name: "新增联签单",
    component: "pc-bidOrderAdd"
  },
  bidOrderEdit: {
    title: "编辑联签单",
    name: "编辑联签单",
    component: "pc-bidOrderEdit"
  },
  bidOrderDetail: {
    title: "联签单详情",
    name: "联签单详情",
    component: "pc-bidOrderDetail"
  },

  bidLedger: {
    title: "采购台账",
    name: "采购台账",
    component: "pc-bidLedger"
  },
  bidLedgerAdd: {
    title: "新增采购台账",
    name: "新增采购台账",
    component: "pc-bidLedgerAdd"
  },
  bidLedgerEdit: {
    title: "编辑采购台账",
    name: "编辑采购台账",
    component: "pc-bidLedgerEdit"
  },
  bidLedgerDetail: {
    title: "采购台账详情",
    name: "采购台账详情",
    component: "pc-bidLedgerDetail"
  },
  //------------jzy-institution-end-----------
  menuNav: {
    title: "菜单导航",
    name: "菜单导航",
    component: "pc-menuNav"
  },
};
